import _regeneratorRuntime from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.array.push.js";
import i18n from '@/lang/lang';
import { loginApi } from '@/api';

import { mapState, mapActions, mapMutations } from 'vuex';
export default {
  name: 'Login',
  data: function data() {
    return {
      account: '',
      password: '',
      showPassword: false,
      isUpgrading: false
    };
  },
  computed: _objectSpread({}, mapState(['projects'])),
  methods: _objectSpread(_objectSpread(_objectSpread({}, mapActions(['getAllGroups'])), mapMutations(['ADD_USER_DETAIL'])), {}, {
    login: function login() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _login$data, login, _userDetailData$demoL, userDetailData;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return loginApi(_this.account, _this.password);
              case 3:
                login = _context.sent;
                if (login !== null && login !== void 0 && (_login$data = login.data) !== null && _login$data !== void 0 && _login$data.success) {
                  userDetailData = login.data.data;
                  if (!((_userDetailData$demoL = userDetailData.demoList) !== null && _userDetailData$demoL !== void 0 && _userDetailData$demoL.length)) {
                    userDetailData.demoList = ['無'];
                  }
                  _this.ADD_USER_DETAIL(userDetailData);
                  localStorage.setItem('userDetail', JSON.stringify(userDetailData));
                  _this.afterLogin();
                }
                _context.next = 10;
                break;
              case 7:
                _context.prev = 7;
                _context.t0 = _context["catch"](0);
                if (_context.t0.msg === 'password incorrect' || _context.t0.msg === 'account not found') {
                  _this.$swal('帳號或密碼錯誤');
                }
              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 7]]);
      }))();
    },
    afterLogin: function afterLogin() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this2.getAllGroups();
              case 2:
                _this2.$router.push({
                  name: _this2.projects[0].homePageName,
                  params: {
                    lang: i18n.locale
                  }
                }).catch(function (err) {
                  return console.log('afterLogin router push has error', err);
                });
              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    }
  })
};